<div class="verify-container">
  <mat-card class="verify-card">
    <mat-card-header class="header-holder">
      <img
        priority
        ngSrc="assets/talentmarket.logo.svg"
        routerLink="/home"
        alt="talentmarket."
        class="logo-card cursor-pointer"
        height="100"
        width="250" />
    </mat-card-header>

    <mat-card-content class="content">
      <!-- Loading State -->
      <div *ngIf="state === 'loading'" class="state-container">
        <mat-spinner diameter="50"></mat-spinner>
        <h2>Verifying your email...</h2>
        <p class="subtitle">Please wait while we verify your email address.</p>
      </div>

      <!-- Success State -->
      <div *ngIf="state === 'success'" class="state-container success">
        <mat-icon class="state-icon success-icon">check_circle</mat-icon>
        <h2>Email Verified!</h2>
        <p class="subtitle">
          Your email has been successfully verified. Your quiz applications are now linked to your account.
        </p>
        <button
          mat-raised-button
          color="primary"
          class="action-btn"
          (click)="goToApplications()">
          Go to My Applications
        </button>
      </div>

      <!-- Error State -->
      <div *ngIf="state === 'error'" class="state-container error">
        <mat-icon class="state-icon error-icon">error</mat-icon>
        <h2>Verification Failed</h2>
        <p class="subtitle">{{ errorMessage }}</p>
        <button
          mat-raised-button
          color="primary"
          class="action-btn"
          (click)="goToLogin()">
          Go to Login
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
